import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Header from './Header';
import SiteTabBar from './SiteTabBar';
import SiteManageNetworksLayout from './site-manage-networks/Layout';
import SiteManageEducatorsLayout from './site-manage-educators/Layout';
import SiteManagePartnersLayout from './site-manage-partners/Layout';
import SiteManageProjectsLayout from './site-manage-projects/Layout';
import SiteManageEventsLayout from './site-manage-events/Layout';
import useDialogConfig from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogConfig';
import useDialogRouter from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogRouter';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import { Helmet } from 'react-helmet-async';

SiteTemplate.propTypes = {
  site: PropTypes.object.isRequired
};

export default function SiteTemplate(props) {
  const { site } = props;

  const { id, route } = useDialogConfig();
  const router = useDialogRouter(id);

  useEffect(() => {
    if (route === '/') {
      router.navigate('/networks');
    }
  }, []);

  if (site.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  const pageMap = {
    '/networks': 'Networks',
    '/educators': 'Educators',
    '/projects': 'Projects'
  };

  const pathname = route.split('?')[0];
  const page = pageMap[pathname] || pathname;

  return (
    <div className="space-y-6 -mt-12">
      <Helmet>
        <title>
          Site: {site.data.name}
        </title>
      </Helmet>
      <Header site={site} />
      <div className="-mx-6">
        <SiteTabBar site={site} />
      </div>
      <div className="space-y-12">
        {pathname === `/networks` && (
          <SiteManageNetworksLayout
            site={site}
            onClose={props.onClose}
          />
        )}
        {pathname === `/educators` && (
          <SiteManageEducatorsLayout
            site={site}
            onClose={props.onClose}
          />
        )}
        {pathname === `/partners` && (
          <SiteManagePartnersLayout
            site={site}
            onClose={props.onClose}
          />
        )}
        {pathname === `/projects` && (
          <SiteManageProjectsLayout
            site={site}
            onClose={props.onClose}
          />
        )}
        {pathname === `/events` && (
          <SiteManageEventsLayout
            site={site}
            onClose={props.onClose}
          />
        )}
      </div>
    </div>
  );
};
